import { format, startOfHour, isEqual, isBefore, addHours, addMinutes } from 'date-fns'

export function formatDate(date, formatStr) {
  return format(addMinutes(date, date?.getTimezoneOffset()), formatStr)
}

export function timeOptions(min, max, isEndTime) {
  const formatStr = 'EEE h:mma'
  const result = []

  let cutoffTime = startOfHour(new Date(max))

  if (isEndTime) {
    cutoffTime = addHours(cutoffTime, 1)
  }

  let cursor = startOfHour(new Date(min))

  while (isEqual(cursor, cutoffTime) || isBefore(cursor, cutoffTime)) {
    result.push({
      name: formatDate(cursor, formatStr),
      value: cursor.getTime(),
    })
    cursor = addHours(cursor, 1)
  }

  return result
}
